/**
 * 缓存相关
 */
 import Vue from 'vue';
 /**
  * 获取缓存
  * @param {*} key 缓存的key
  * @returns 
  */
 export function getSession(key) {
   const value = sessionStorage.getItem(key);
   return JSON.parse(value);
 }
 
 /**
  * 设置缓存
  * @param {*} key 缓存的key
  * @param value 缓存的value
  * @returns 
  */
 export function setSession(key, value) {
   sessionStorage.setItem(key, JSON.stringify(value));
 }
 
 /**
  * 指定移除缓存
  * @param {*} key 缓存的key
  * @returns 
  */
 export function removeSession(key) {
   sessionStorage.removeItem(key);
 }
 
 /**
  * 清除全部缓存
  * @returns 
  */
 export function clearSession() {
   sessionStorage.clear();
 }
 
 Vue.prototype.$getSession = getSession;
 Vue.prototype.$setSession = setSession;
 Vue.prototype.$removeSession = removeSession;
 Vue.prototype.$clearSession = clearSession;
 